<template>
  <div class="grade-management">
    <topBar/>
    <gradeList/>
  </div>
</template>

<script>
import topBar from "./components/grademanagement-topbar/gradeManagement-topBar";
import gradeList from "./components/grademanagement-gradelist/gradeManagement-gradeList";
export default {
  components: {
    topBar,
    gradeList,
  },
};
</script>

<style scoped lang="scss">
@import "./gradeManagement.scss";
</style>